import { useState, useEffect } from 'react';
import getAllRoomsForOfficeOnDate from '../services/rooms.service';
import type RoomObsolete from '../../offices/models/room/room-obsolete';
import { useKeycloak } from '../../authentication/keycloak/KeycloakProvider';

interface RoomsState {
  readonly initialized: boolean;
  readonly error?: boolean;
  readonly rooms?: RoomObsolete[];
}

interface OfficeProps {
  officeId: string | undefined;
  date: string;
}

const useRoomsForOfficeOnDate = ({ officeId, date }: OfficeProps): RoomsState => {
  const [state, setState] = useState<RoomsState>({ initialized: false });
  const keycloak = useKeycloak();

  useEffect(() => {
    const getRooms = async (): Promise<void> => {
      if (!officeId) {
        return;
      }
      try {
        const rooms = await getAllRoomsForOfficeOnDate(keycloak, officeId, date);
        setState({ initialized: true, rooms });
      } catch (error) {
        setState({ initialized: false, error: true });
      }
    };
    getRooms();
  }, [setState, keycloak, officeId, date]);

  return state;
};

export default useRoomsForOfficeOnDate;
